import React from "react";
import { CommonUtils } from "../../utilities";
import "./Text.scss";
import TextProps from "./Text.types";

// const Text = ({ children }: TextProps) => <>{children}</>;
// Text.Title = Title;
// Text.Normal = Normal;

const Title = (props: TextProps) => {
  const { size, children, fonts, className = "", onTextClick } = props;
  const commonProps = {
    ...props,
    className: `text_title font--${fonts} ${className}`,
    onClick: onTextClick,
  };
  const updateProps = CommonUtils.getFilteredProps(commonProps);
  switch (size) {
    case "h1":
      return <h1 {...updateProps}>{children}</h1>;
    case "h2":
      return <h2 {...updateProps}>{children}</h2>;
    case "h3":
      return <h3 {...updateProps}>{children}</h3>;
    case "h4":
      return <h4 {...updateProps}>{children}</h4>;
    case "h5":
      return <h5 {...updateProps}>{children}</h5>;
    default:
      return <h6 {...updateProps}>{children}</h6>;
  }
};

const Normal = (props: TextProps) => {
  const { children, fonts, fontSize, className = "", onTextClick } = props;
  const commonProps = {
    ...props,
    style: { fontSize },
    className: `text_normal font--${fonts} ${className}`,
    onClick: onTextClick,
  };
  const updateProps = CommonUtils.getFilteredProps(commonProps);
  return <p {...updateProps}>{children}</p>;
};

const Danger = (props: TextProps) => {
  const { children, fonts, fontSize, className = "", onTextClick } = props;
  const commonProps = {
    ...props,
    style: { fontSize },
    className: `text_normal text_danger font--${fonts} ${className}`,
    onClick: onTextClick,
  };
  const updateProps = CommonUtils.getFilteredProps(commonProps);
  return <p {...updateProps}>{children}</p>;
};

const Link = (props: TextProps) => {
  const {
    children,
    fonts,
    href,
    fontSize,
    className = "",
    onTextClick,
  } = props;
  const cProp = {
    ...props,
    style: { fontSize },
    className: `text_normal text_link font--${fonts} ${className}`,
  };
  const commonProps = href
    ? {
        ...cProp,
      }
    : {
        ...cProp,
        onClick: onTextClick,
      };
  const updateProps = CommonUtils.getFilteredProps(commonProps);
  return <a {...updateProps}>{children}</a>;
};

const Text = (props: TextProps) => {
  switch (props.type) {
    case "title":
      return <Title {...props} />;
    case "link":
      return <Link {...props} />;
    case "danger":
      return <Danger {...props} />;
    default:
      return <Normal {...props} />;
  }
};

export default Text;
